import { render, staticRenderFns } from "./DuplicateReview.vue?vue&type=template&id=6a9bb564&scoped=true"
import script from "./DuplicateReview.vue?vue&type=script&lang=js"
export * from "./DuplicateReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9bb564",
  null
  
)

export default component.exports